import { Component, Input } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { SharedService } from 'app/shared/services/shared.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { UserService } from '../../../shared/services/user.service';
@AutoUnsubscribe()
@Component({
  selector: 'cdn-file-update-component',
  templateUrl: './cdn-file-update.component.html',
  styleUrls: ['./cdn-file-update.component.scss'],
})
export class CdnFileUpdateComponent {
  public formData: any;
  public isUploading: boolean;
  public maxFileSize: number;
  public subscriptions: Array<any>;
  @Input() public data: any;
  constructor(
    public sharedService: SharedService,
    public modalsService: ModalsService,
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public userService: UserService,
    public ga: GoogleAnalyticsService
  ) {
    this.formData = {
      filename: this.modalsService.modalData.data.originalName,
      files: [],
    };
    this.isUploading = false;
    this.maxFileSize = 50;
    this.subscriptions = [];
  }

  validateForm() {
    if (this.sharedService.isEmpty(this.formData.filename)) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('FILE_NAME_IS_REQUIRED'), 'error');
      return false;
    } else if (!this.sharedService.validateFilename(this.formData.filename)) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('FILENAME_ERROR'), 'error');
      return false;
    } else if (this.formData.files.length === 0) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('PLEASE_SELECT_A_FILE'), 'error');
      return false;
    } else if (this.formData.files[0].size > this.maxFileSize * 1024 * 1024) {
      this.sharedService.showFlashMessage(
        this.dictionaryService.get('FILE_SIZE_EXCEED_ERROR')(this.maxFileSize),
        'error'
      );
      return false;
    }
    return true;
  }
  ngOnDestroy() {}
  upload() {
    if (this.validateForm()) {
      const params: any = {
        id: this.modalsService.modalData.data.id,
      };
      this.isUploading = true;
      this.subscriptions.push(
        this.httpService.upload('cdn_files/updateFile', params, this.formData.files[0]).subscribe(
          (response) => {
            if (!response.errors) {
              this.sharedService.showFlashMessage(this.dictionaryService.get('FILE_UPLOADED_SUCCESSFULLY'), 'success');
              this.sharedService.sendMessage('CDN_FILE_UPDATE');
            } else {
              if (response.errors.file) {
                this.sharedService.showFlashMessage(response.errors.file, 'error');
              } else {
                this.sharedService.showErrorFlashMessage();
              }
            }
            this.isUploading = false;
            this.modalsService.hideModal();
          },
          (error) => {
            this.sharedService.showErrorFlashMessage();
            this.isUploading = false;
            this.modalsService.hideModal();
          }
        )
      );
    }
  }
  fileChange($event: any) {
    this.formData.files = $event;
    if (this.sharedService.isEmpty(this.formData.filename) && $event.length > 0) {
      this.formData.filename = $event[0]['name'];
    }
  }

  ngOnInit() {}
}
